// Routes where SimulatorLayout renders the immersive, height-locked "Coach
// Split" simulator. Shared so the pieces that react to "user is in a live
// simulation" stay in sync: AppShell (locks the viewport) and NavMenu
// (collapses the top nav to reclaim vertical height). Keep this list in step
// with the pages under app/simulator/* that render SimulatorLayout.
export const FULL_VIEWPORT_SIMULATOR_ROUTES = [
  "/simulator/cold-call",
  "/simulator/discovery",
  "/simulator/management",
  "/simulator/objections",
  "/simulator/on-the-fly",
  "/simulator/pitch",
  "/simulator/plays",
];

// The persona chat runner lives on a dynamic segment, so it can't join the
// prefix list above — a prefix would also capture its /results page, which is
// a normal scrolling page.
const PERSONA_CHAT_ROUTE_RE = /^\/simulator\/personas\/[^/]+\/chat\/?$/;

/** True when the path is the persona chat runner (not its results page). */
export function isPersonaChatRoute(pathname) {
  return PERSONA_CHAT_ROUTE_RE.test(pathname || "");
}

/** True when the path is one of the immersive simulator runner routes. */
export function isSimulatorRoute(pathname) {
  const path = pathname || "";
  return (
    FULL_VIEWPORT_SIMULATOR_ROUTES.some((route) => path.startsWith(route)) ||
    isPersonaChatRoute(path)
  );
}
